"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Animate.default;
  }
});

var _Animate = _interopRequireDefault(require("./Animate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }